"use strict";

class StationSettingsOverviewCtrl {
    constructor(
        $rootScope,
        $timeout,
        $scope,
        $state,
        $transitions
    ) {
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.$scope = $scope;
        this.$state = $state;

        this.cmOpen = {
            settings: false,
            stationInformation: false,
            visuals_strings: false,
            datamodel: false,
            communication: false,
            message: false,
            export: false,
            api: false,
            multi: false,
            modules: false,
        };

        this.$rootScope.saveDisabled = false;
        this.$rootScope.saveHiden = false;
        this.$rootScope.save = () => {
            //placeholder. Used to save the settings

            return null;
        };

        this.titleSuffix = '';

        this.checkIfSubMenuShouldOpen();
        this.$timeout(() => {
            this.updateHeader();

        });
        $transitions.onSuccess({ }, function(transition) {

            let to = transition.to();
            if(to.name.startsWith('stationsettings') > -1) {
                this.updateHeader();
            }
        }.bind(this));
    }

    updateHeader() {
        let state = this.$state.current.name;
        let srefVal = state + '()';

        //datamodel exceptions
        if(state.indexOf('datamodel') > -1) {
            let modelName = this.$state.params.modelName;
            srefVal = 'stationsettings.datamodel({modelName: \'' + modelName + '\'})';
        }

        let srefEl = angular.element('*[rm-sref="' + srefVal + '"]');

        if(srefEl.length == 1) {
            //check if sref is an parent or a child
            if(srefEl.attr('md-heading')) {
                this.titleSuffix = '> ' + srefEl.attr('md-heading');
            } else {
                let childName = srefEl.find('div').html();
                let parentEl = srefEl.parent().parent();
                let parentName = parentEl.attr('md-heading');

                this.titleSuffix = '> ' + parentName + ' > ' + childName;
            }
        }
    }

    checkIfSubMenuShouldOpen() {
        let currState = this.$state.current;
        let splitted = currState.name.split('.');

        if(splitted[1]) {
            if(typeof this.cmOpen[splitted[1]] != 'undefined') {
                this.cmOpen[splitted[1]] = true;
            }
        }
    }
}

StationSettingsOverviewCtrl.$inject = [
    '$rootScope',
    '$timeout',
    '$scope',
    '$state',
    '$transitions'
];

module.exports = StationSettingsOverviewCtrl;